import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

Sale01.propTypes = {
    data: PropTypes.object,
};

function Sale01({ data }) {
    const FE_WEB_URL = 'https://app.tradiora.id';
    const title = data?.title || 'Siap Memulai Perjalanan Investasi Anda?';
    const desc = data?.description || 'Gabung dengan ribuan investor lainnya. Dapatkan bimbingan mentor profesional. Mulai sekarang!';
    const btnText = data?.button_text || 'Daftar Sekarang';
    const btnLink = data?.button_link || FE_WEB_URL;

    return (
        <section className="section-sale">
            <div className="container">
                <div className="row align-item-center">
                <div className="col-md-7">
                    <div className="block-text">
                    <h4 className="heading">{title}</h4>
                    <p className="desc">{desc}</p>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="button">
                    {btnLink.startsWith('http') ? <a href={btnLink}>{btnText}</a> : <Link to={btnLink}>{btnText}</Link>}
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
}

export default Sale01;